// extracted by mini-css-extract-plugin
export var askAiIcon = "_mt-j";
export var category = "_mt-9";
export var categoryHeader = "_mt-e";
export var container = "_mt-0";
export var group = "_mt-a";
export var groupItems = "_mt-f";
export var groupSeparator = "_mt-k";
export var loading = "_mt-1";
export var noResults = "_mt-3";
export var placeholder = "_mt-2";
export var resultContent = "_mt-5";
export var resultIcon = "_mt-c";
export var resultItem = "_mt-g";
export var resultMeta = "_mt-8";
export var resultSubtitle = "_mt-7";
export var resultSuffix = "_mt-i";
export var resultTitle = "_mt-6";
export var resultsList = "_mt-4";
export var searchGroup = "_mt-d";
export var selected = "_mt-h";
export var subgroup = "_mt-b";